import httpServices from 'services/http.service';
import { API_URLS } from 'config/constants';

export interface UserEventListParams {
  type?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const getUserEvents = (params?: UserEventListParams) => (
  httpServices.get(API_URLS.USER_EVENT.LIST, { params })
);
